const renderPrice = (pennies: number) => {
  const dollars = pennies / 100;
  const formattedDollars = dollars.toFixed(2);
  return `$${formattedDollars}`;
};

export default renderPrice;
